import { fetchBrands } from "../../services/api";
export default {
  namespaced: true,
  state: {
    all: [],
  },
  getters: {
     mappedById: (state) => {
       return state.all.reduce((total, brand) => {
         total[brand.id] = brand;
         return total;
       }, {});
     },

  },
  actions: {
    fetch: ({ commit, rootState }) => {
      return fetchBrands(rootState.environmentId).then(({ data }) => {
        commit('SET_BRANDS', data);
      });
    },
  },
  mutations: {
    SET_BRANDS: (state, data) => {
      state.all = data;
    },
  },
};
